import { translate } from "app/filters/i18nFilter";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import { getCrmName } from "app/pages/sales-intelligence/utils/crm";

import manageIntegrationTrackingService from "../../services/tracking/manageIntegrationTrackingService";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import type { DropdownProps } from "../IntegrationSetting";
import { IntegrationSetting } from "../IntegrationSetting";

import { useAccountStatusProps } from "./useAccountStatusProps";

export const AccountStatusSettings = () => {
    const { integrationName: crm } = getIntegrationNameFromUrl() as {
        integrationName: Integration;
    };
    const {
        isCrmLabelEnabled: isEnabled,
        setIsCrmLabelEnabled,
        crmFields,
        statusField,
        setStatusField,
        isLoadingStatusField,
    } = useAccountStatusProps(crm);

    const crmNameObj = { crmName: getCrmName(crm) };

    const trackToggle = (isEnabledToggle: boolean) => {
        manageIntegrationTrackingService.trackAccountStatusToggle(isEnabledToggle, crm);
    };

    const handleToggle = (isEnabledToggle: boolean) => {
        setIsCrmLabelEnabled(isEnabledToggle);
        trackToggle(isEnabledToggle);
    };

    const handleSelectStatusField = (fieldName: string) => {
        setStatusField(fieldName);

        manageIntegrationTrackingService.trackAccountSelectStatusField(crm);
    };

    const getDropdownProps = (): DropdownProps<string> => {
        return {
            description: translate("si.manage-integration.show-in-crm.dropdown.description", crmNameObj),
            options: crmFields,
            value: statusField || "",
            onSelect: handleSelectStatusField,
            isLoading: isLoadingStatusField,
            tooltipContentInfo: translate("si.manage-integration.show-in-crm.dropdown.info", crmNameObj),
        };
    };

    return (
        <IntegrationSetting
            dataAutomation={`${crm}-account-status-setting`}
            title={translate("si.manage-integration.show-in-crm.title", crmNameObj)}
            content={translate("si.manage-integration.show-in-crm.description", crmNameObj)}
            onToggle={handleToggle}
            isEnabled={isEnabled}
            dropdownProps={getDropdownProps()}
        />
    );
};
